<template>
    <b-alert show v-if="show == 1" variant="info">
        <b-row align-v="center">
            <b-col cols="auto">
                <b-icon icon="info-circle" scale="1.5"></b-icon>
            </b-col>
            <b-col>
                Vous résidez dans un pays avec lequel la France a signé une convention bilatérale prévoyant la prise en charge des soins, vous n'êtes pas soumis à la condition de 15 ans minimum de cotisations<b-link v-if="casParticuliers == 1" href="#" id="cas-particuliers"> sauf cas particuliers</b-link>.
                <b-tooltip v-if="casParticuliers == 1" target="cas-particuliers" triggers="hover">
                    Les pensionnés au RSI sont soumis aux 15 années de cotisations pour certains pays comme la Serbie, la Bosnie-Herzégovine, le Monténégro, le Kosovo et la Macédoine.
                </b-tooltip>
            </b-col>
        </b-row>
    </b-alert>
</template>

<script>
export default {
  name: 'AlerteInfoNonSoumis15AnneesCotisations',
  props: [
      'show',
      'casParticuliers'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/AlerteInfoNonSoumis15AnneesCotisations.vue